import { ConfAccount } from "../context/account/paramsAccount";
import { saveCredentials } from "../functions/localStorage/saveLocalStorage";
const apiUrl = process.env.REACT_APP_API_URL;
export const apiPost = async <Interface>(url: string, data: Interface, showError: (message: string) => void) => {
  try {
    const response = await fetch(`${apiUrl}${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const dataResponse = await response.json();
    if (dataResponse.message) {
      showError(dataResponse.message);
      return
    } else {
      return dataResponse;
    }
  } catch (error: any) {
    showError(error.message);
  }
};
const handleApiResponse = async (response: Response, url: string, token: string | null, conf: any, setConf: any, showError: (message: string) => void) => {
  const dataResponse = await response.json();
  const newConf = {
    ...conf,
    token: null,
    user: {
      ...conf.user,
      isConnected: !conf.user.isConnected,
    },
  };
  switch (true) {
    case url === "/posts/user-logout" &&
      (dataResponse[0]?.ff_session_fermer === false || dataResponse[0]?.ff_session_fermer === true):
      setConf(newConf)
      await saveCredentials(newConf,
        newConf,
        setConf,
        conf.user.user_code,
      );
      // window.location.href = '/';
      break;
    case dataResponse?.message === "Base de données 'base_de_donnees1' non configurée.":
      setConf(newConf,
        conf,
        setConf)
      apiPostDeconnect('/posts/user-logout', token, showError)
      await saveCredentials(newConf,
        conf,
        setConf,
        conf.user.user_code);
      // window.location.href = '/';
      break;
    case dataResponse?.message === "Invalid token":
      setConf(newConf)
      // apiPostDeconnect('/posts/user-logout', id, token, showError)
      await saveCredentials(newConf,
        conf,
        setConf,
        conf.user.user_code);
      // window.location.href = '/';
      break;
    case dataResponse?.error === "Invalid token":
      setConf(newConf)
      apiPostDeconnect('/posts/user-logout', token, showError)
      await saveCredentials(newConf,
        conf,
        setConf,
        conf.user.user_code);
      // window.location.href = '/';
      break;
    case dataResponse?.message === "Invalid token (no session)":
      setConf(newConf)
      apiPostDeconnect('/posts/user-logout', token, showError)
      await saveCredentials(newConf,
        conf,
        setConf,
        conf.user.user_code);
      // window.location.href = '/';
      break;
    case dataResponse?.message === "Invalid session":
      setConf(newConf)
      apiPostDeconnect('/posts/user-logout', token, showError)
      await saveCredentials(newConf,
        conf,
        setConf,
        conf.user.user_code);
      // window.location.href = '/';
      break;
    case dataResponse?.error === "Base de données non trouvée pour ce lien.":
      setConf(newConf)
      apiPostDeconnect('/posts/user-logout', token, showError)
      await saveCredentials(newConf,
        conf,
        setConf,
        conf.user.user_code);
      // window.location.href = '/';
      break;
    case dataResponse?.message === "Une erreur s'est produite lors de la connexion à la base de données":
      setConf(newConf)
      apiPostDeconnect('/posts/user-logout', token, showError)
      await saveCredentials(newConf,
        conf,
        setConf,
        conf.user.user_code);
      // window.location.href = '/';
      break;
    case dataResponse === null:
      setConf(newConf)
      apiPostDeconnect('/posts/user-logout', token, showError)
      await saveCredentials(newConf,
        conf,
        setConf, conf.user.user_code);
      // window.location.href = '/';
      break;
    case dataResponse === undefined:
      setConf(newConf)
      apiPostDeconnect('/posts/user-logout', token, showError)
      await saveCredentials(newConf,
        conf,
        setConf, conf.user.user_code);
      window.location.href = '/';
      break;
    case dataResponse?.message === "La fiche retour a déjà été signée":
      showError(dataResponse.message);
      break;
    case dataResponse?.message === 'Vous devez être connecté pour accéder à cette ressource':
      setConf(newConf)
      apiPostDeconnect('/posts/user-logout', token, showError)
      await saveCredentials(newConf,
        conf,
        setConf,
        conf.user.user_code);
      window.location.href = '/';
      break
    case dataResponse?.message === "Des erreurs de validation sont survenues.Tous les champs ne sont pas remplis.":
      showError(dataResponse.message);
      break;

    default:
      return dataResponse;
  }
};

export const apiPostWToken = async (url: string, data: any, token: string | null, conf: ConfAccount, setConf: any, showError: (message: string) => void) => {
  const requestData = data ? JSON.stringify(data) : JSON.stringify({});
  try {
    const response: any = await fetch(`${apiUrl}${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: requestData,
    });
    return await handleApiResponse(response, url, token, conf, setConf, showError);
    // return await handleApiResponse(response, url, token, conf, setConf, showError);
  } catch (error: any) {
    showError(error.message);
  }
};

export const apiPostDeconnect = async <Interface>(url: string, token: string | null, showError: (message: string) => void) => {
  try {
    const response: any = await fetch(`${apiUrl}${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
    });
    window.location.href = '/';
  } catch (error: any) {
    showError(error.message);
  }
};
